import React from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { glassPanel } from '../../utils/demoUi';
import { referralLocalNotice } from './PartnerReferrals';
import { ReferralCard } from './ReferralCard';
export function MyReferrals() {
  const {
    state
  } = useDevelopmentDemo();
  const referrals = state.referrals.filter(referral => referral.participantId === state.ui.actingParticipantId);
  return <div data-id="element-774" data-mp="2czt4m0uc75qg">
      <DemoSectionHeader title="My Referrals" description="Referrals the program team recorded with your agreement, showing exactly what was shared and with whom." data-id="element-775" data-mp="2czjg6hoxx6mv" />
      <p className="mb-6 text-sm text-ink-muted" data-id="element-776" data-mp="2mqnudf6skngn">{referralLocalNotice}</p>
      {referrals.length === 0 ? <div className={`${glassPanel} p-10 text-center`} data-id="element-777" data-mp="1pbjn3b45p454">
          <p className="font-heading font-bold text-ink-dark" data-id="element-778" data-mp="1p8xfxcl6gqnf">No referrals</p>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-779" data-mp="1u80ece6njymf">Nothing has been shared with a partner organization.</p>
        </div> : <ul className="space-y-4" data-id="element-780" data-mp="3tum8rr6myfmj">
          {[...referrals].reverse().map(referral => <li key={referral.id} data-id="element-781" data-mp="3p3maoils5rig">
              <ReferralCard referral={referral} canUpdate={false} data-id="element-782" data-mp="3p2kp3k751mmh" />
            </li>)}
        </ul>}
    </div>;
}